import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = ["id", "aria-labelledby"]
const _hoisted_2 = { class: "modal-dialog modal-dialog-centered" }
const _hoisted_3 = { class: "modal-content shadow-4" }
const _hoisted_4 = { class: "modal-body" }
const _hoisted_5 = { class: "text-center py-5 px-5" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "icon icon-shape rounded-circle bg-soft-danger text-danger text-lg" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "bi bi-exclamation-octagon-fill" })
], -1)
const _hoisted_7 = ["innerHTML"]
const _hoisted_8 = { class: "text-sm text-muted" }
const _hoisted_9 = { class: "modal-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: "modal",
    tabindex: "-1",
    "aria-hidden": "true",
    id: _ctx.id,
    "aria-labelledby": _ctx.id
  }, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _hoisted_6,
            _createElementVNode("h3", {
              class: "mt-7 mb-4",
              innerHTML: _ctx.title
            }, null, 8, _hoisted_7),
            _createElementVNode("p", _hoisted_8, _toDisplayString(_ctx.text), 1),
            _renderSlot(_ctx.$slots, "body")
          ])
        ]),
        _createElementVNode("div", _hoisted_9, [
          (_ctx.callbackAction1AutoDismiss === true)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                type: "button",
                class: "btn btn-sm btn-neutral",
                "data-bs-dismiss": "modal",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('callbackAction1')))
              }, _toDisplayString(_ctx.action1), 1))
            : (_openBlock(), _createElementBlock("button", {
                key: 1,
                type: "button",
                class: "btn btn-sm btn-neutral",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('callbackAction1')))
              }, _toDisplayString(_ctx.action1), 1)),
          (_ctx.callbackAction2AutoDismiss === true)
            ? (_openBlock(), _createElementBlock("button", {
                key: 2,
                type: "button",
                class: "btn btn-sm btn-danger",
                "data-bs-dismiss": "modal",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('callbackAction2')))
              }, _toDisplayString(_ctx.action2), 1))
            : (_openBlock(), _createElementBlock("button", {
                key: 3,
                type: "button",
                class: "btn btn-sm btn-danger",
                onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('callbackAction2')))
              }, _toDisplayString(_ctx.action2), 1))
        ])
      ])
    ])
  ], 8, _hoisted_1))
}